<template>
    <div class="c-calendar-components">
        <div class="loader" v-if="isLoading"><i class="fas fa-circle-notch fa-spin"></i> Loading...</div>
        <DateNavigation :first-instance="firstInstance" :last-instance="lastInstance" :next-button="false" :previous-button="false"/>


        <FullCalendar
                ref='fullCalendar'
                :options="calendarOptions"
        />

        <DateNavigation :first-instance="firstInstance" :last-instance="lastInstance" :next-button="false" :previous-button="false"/>


    </div>

</template>

<script>
    import FullCalendar from '@fullcalendar/vue'
    import momentPlugin from '@fullcalendar/moment'
    import moment from 'moment'
    import dayGridPlugin from '@fullcalendar/daygrid'
    import listPlugin from '@fullcalendar/list'
    import DateNavigation from "./DateNavigation";
    import {EventBus} from "../event-bus";
    import debounce from 'lodash.debounce'

    export default {
        name: 'Calendar',
        props: ['firstInstance', 'lastInstance'],
        components: {
            FullCalendar,
            DateNavigation
        },
        data() {
            return {
                calendarOptions: {
                    headerToolbar: {
                        start: '',
                        center: 'title',
                        end: 'prev,next'
                    },
                    footerToolbar: false,
                    height: 'auto',
                    plugins: [dayGridPlugin, momentPlugin, listPlugin],
                    initialView: this.setInitialView(),
                    events: {
                        url: window.ajax.url,
                        method: 'GET',
                        extraParams: {
                            action: 'basethemeCalendarRequest'
                        },
                    },
                    displayEventTime: false,
                    eventContent: this.eventContent,
                    validRange: this.validRange,
                    loading: this.loading,
                },
                isLoading: true,
                calendarApi: null
            }
        },
        mounted() {
            this.addEventListeners()
            this.calendarApi = this.$refs.fullCalendar.getApi()
            this.urlParamJumpMonth()
        },
        methods: {
            addEventListeners() {
                EventBus.$on('next', this.nextMonth)
                EventBus.$on('previous', this.previousMonth)
                EventBus.$on('gotoMonth', this.gotoMonth)

                window.addEventListener('resize', debounce(this.onResizeUpdateView, 200))
            },
            eventContent(arg) {
               return {
                   html: arg.event.title
               }
            },
            gotoMonth(selectedMonth) {
                let month = moment(selectedMonth, 'MMMM YYYY').startOf('month').format('YYYY-MM-DD')
                this.calendarApi.gotoDate(month)
                this.updateMonth(selectedMonth, 'gotoMonth')
            },
            loading(isLoading) {
                this.isLoading = isLoading
            },
            nextMonth() {
                this.calendarApi.next()
                this.updateMonth(this.calendarApi.currentData.viewTitle, 'next')
            },
            onResizeUpdateView() {
                const view = window.innerWidth < 1024 ? 'listWeek' : 'dayGridMonth'
                this.calendarApi.changeView(view)
            },
            previousMonth() {
                this.calendarApi.prev()
                this.updateMonth(this.calendarApi.currentData.viewTitle, 'previous')
            },
            setInitialView() {
                return window.innerWidth < 1024 ? 'listWeek' : 'dayGridMonth'
            },
            urlParamJumpMonth() {
                const urlParams = new URLSearchParams(window.location.search)

                if (urlParams.has('month')) {
                    const selectedMonth = urlParams.get('month').replace('-', ' ')
                    this.gotoMonth(selectedMonth)
                }
            },
            updateMonth(month, button) {
                EventBus.$emit('updateMonth', month, button)
            },
            validRange(nowDate) {
                return {
                    start: this.firstInstance !== undefined ? this.firstInstance : nowDate,
                    end: this.lastInstance !== undefined ? this.lastInstance : false,
                }
            },
        },
    }
</script>

<style lang='css'>
    @import '~@fullcalendar/common/main.css';
    @import '~@fullcalendar/daygrid/main.css';
    @import '~@fullcalendar/list/main.css';
</style>

